import { Badge } from "@similarweb/ui-components";

const FilterNewTag = () => <Badge type="new" />;

export default FilterNewTag;
